<template>
  <div>
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    <h2 class="mb-3">My Training Courses</h2>

    <AppLoader v-if="isLoading" class="text-center" small />
    <b-row class="ml-2 mr-2" style="height: calc(100vh - 200px); overflow:auto;">
      <b-col cols="3" v-for="(training,index) in training" :key="index">
        <b-card bg-variant="default" class="mb-2" style="height:300px;">
          <b-card-text class="my-3">
            <font-awesome-icon icon="graduation-cap" size="5x" style="color:#3DDC97;" />
          </b-card-text>
          <b-card-text>{{training.task_title}}</b-card-text>

          <b-card-text>
            <span :class="'badge badge-' + getTaskStatusVariant(training.task_status)">{{ getTaskStatusText(training.task_status) }}</span>
          </b-card-text>

          <b-button
            variant="outline-primary"
            @click="getTaskForm(training.form_id,training.type,training.id)"
          >{{getTaskButtonStatus(training.task_status)}}</b-button>
        </b-card>

        <p></p>

        <!-- to show signature form -->
        <b-card
          v-if="training.task_status == 4 && showSIgnatureData(training) && showSIgnatureData(training).id"
          bg-variant="default"
          class="mb-2"
          style="height:300px;"
        >
          <b-card-text class="my-3">
            <font-awesome-icon icon="pen" size="4x" style="color:#3DDC97;" />
          </b-card-text>
          <b-card-text>{{showSIgnatureData(training).title || ''}}</b-card-text>

          <b-button
            v-if="training.task_status == 4"
            variant="outline-dark"
            @click="downloadPdf(training,'/download/cod')"
          >
            <font-awesome-icon icon="file-pdf" />
          </b-button>
          <!-- @click="onOpenSignatureModal(showSIgnatureData(training))" -->
          <!-- <b-button
            @click="downloadPdf(questionnaire,'/download/questionnaire')"
            variant="outline-primary"
          >Dowload</b-button> -->
        </b-card>

        <!-- signature modal -->
        <b-modal
          v-model="showSignatureModal"
          hide-header-close
          no-close-on-esc
          no-close-on-backdrop
          modal-header-close="No"
          scrollable
          title="Code of Conduct"
          size="xl"
        >
          <template v-slot:modal-footer>
            <b-button @click="resetModal">Close</b-button>
            <!-- <b-button >Complete</b-button> -->
          </template>
          <SignaturePad
            v-if="showSig"
            :isPreview="true"
            :fieldData="showSIgnatureData(training)"
            :sectionIndex="0"
            :fieldIndex="1"
            :isDisabled="1"
          />
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import config from "./../configs/config";
import AppLoader from "../components/Loader/Loader";
import { Helper } from "../helpers";
import { mapGetters, mapActions, mapMutations } from "vuex";
import SignaturePad from "../components/templatesConstants/signature";
import moment from "moment";
import { HTTP } from "../utils/HTTP";
export default {
  name: "MyTPPPage",
  components: {
    AppLoader,
    SignaturePad
  },
  data() {
    return {
      training: [],
      signatureForm: null,
      formButton: false,
      formSchema: null,
      showSignatureModal: false,
      showSig: false,
      breadcrumbs: [
        {
          text: "Dashboard",
          // href: "/dashboard"
          href: "/onboarding/dashboard"
        },

        {
          text: "Training",
          active: true
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading"
    })
  },
  mounted() {
    this.getTasks();
  },

  beforeRouteLeave(to, from, next) {
    if (this.formButton) {
      next();
    } else if (to.name == "dashboard-third-party" || to.name == "login") {
      next();
    } else {
      next(false);
    }
  },

  methods: {
    initializeFormData() {
      console.log("------initializeFormData---------- ");
      if (
        this.$store.state.getUserFormSubmitArray &&
        this.$store.state.getUserFormSubmitArray.length
      ) {
        this.$store.state.userFormSubmitArray = this.$store.state.getUserFormSubmitArray;
        console.log("loading previously saved data....");
      } else {
        console.log("loading new data....");
        this.$store.state.userFormSubmitArray = [];
        let tempForm = _.cloneDeep(this.signatureForm);
        this.$store.state.userFormSubmitArray.push({
          elements: [],
          elementId: this.signatureForm.id,
          elementInputType: this.signatureForm.inputType,
          elementTitle: this.signatureForm.label,
          language: this.selectedLanguage
        });
      }
      // console.log("this.$store.state.userFormSubmitArray", this.$store.state.userFormSubmitArray)
    },

    getTaskFormType(value) {
      let type = "Questionniare";
      if (value == 2) {
        type = "Survey";
      } else if (value == 3) {
        type = "Training";
      } else if (value == 4) {
        type = "Exam";
      }
      return type;
    },

    getTaskButtonStatus(taskStatus) {
      let status = "";
      if (taskStatus == 4) {
        status = "Review";
      } else if (taskStatus == 1) {
        status = "Continue";
      } else if (taskStatus == 0) {
        status = "Start";
      }
      return status;
    },

    getTaskStatusVariant(taskStatus) {
      if (taskStatus == 4) {
        return "success";
      } else if (taskStatus == 1) {
        return "warning";
      } else if (taskStatus == 0) {
        return "primary";
      }
      return "";
    },
    getTaskStatusText(taskStatus) {
      let status = "";
      if (taskStatus == 4) {
        status = "COMPLETE";
      } else if (taskStatus == 1) {
        status = "IN PROGRESS";
      } else if (taskStatus == 0) {
        status = "NOT STARTED";
      }
      return status;
    },

    age(value) {
      // console.log(value);
      let localeData = moment.updateLocale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "hello, a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        }
      });
      //return moment(value).fromNow();

      return moment(value).fromNow();
    },

    async getTasks() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      let userId = localStorage.getItem("userId");
      try {
        let result = await HTTP(
          "post",
          "v1/mytpp/tasks",
          {
            userId: userId
          },

          {
            Authorization: token
          },
          null,
          true
        );
        this.training = result.data.trainingWithTests || [];
        // let form = result.data.task.form.schema;
      } catch (error) {}
    },

    async getTaskForm(formId, formType, taskId) {
      this.formButton = true;
      localStorage.removeItem("taskId");
      localStorage.removeItem("activeFormId");
      localStorage.removeItem("activeFormSchema");
      localStorage.removeItem("taskFormData");
      localStorage.removeItem("activeTaskStatus");
      localStorage.setItem("taskId", taskId);
      let userId = localStorage.getItem("userId");
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = await HTTP(
        "post",
        "v1/mytpp/task/" + taskId,
        {
          userId: userId,
          formType: formType
        },
        {
          Authorization: token
        },
        null,
        true
      );

      if (result.data.task && result.data.task) {
        // alert(result.data.task.task_status);
        let form = result.data.task.form.schema;
        let form_data = JSON.parse(result.data.task.form_data);
        //  console.log("result.data.task.form", JSON.parse(result.data.task.form_data))x
        this.$store.state.userFormSubmitArray = form_data;
        localStorage.setItem("activeFormId", formId);
        localStorage.setItem(
          "activeOnboardingId",
          result.data.task.onboarding_id
        );
        localStorage.setItem("activeFormSchema", form);
        localStorage.setItem("activeTaskStatus", result.data.task.task_status);
        localStorage.setItem(
          "rekatedTaskIds",
          result.data.task.form.related_task_ids
        );

        let newRoute = "";
         if (formType == 11) {
          if (form_data && form_data.slideStatus) {
            localStorage.setItem("activeSlideIndex", form_data.slideStatus - 1);
          } else {
            localStorage.setItem("activeSlideIndex", 0);
          }
          newRoute = "/user-training-test";
        } else {
          
          newRoute = "/dashboard";
        }
        //window.open("http://localhost:1090"+newRoute,'','postwindow');
        this.$router.push({
          path: newRoute,
          params: {
            from: "/dashboard"
          }
        });
      }
    },

    showSIgnatureData(training) {
      // console.log("asasas=-----", training)
      let schema = JSON.parse(training.schema);
      // console.log("sce", schema);
      if (schema.linkedTraining && schema.linkedTraining.id) {
        // let linkForm = JSON.parse(schema.linkedTraining.shcema);
        // console.log("sce", linkForm.formSection[0].formElements[0]);
        // this.signatureForm = linkForm.formSection[0].formElements[0];
        // return linkForm.formSection[0].formElements[0];
        return schema.linkedTraining;
      }else{
        return null
      }
    },

    onOpenSignatureModal(data) {
      this.getFormData(data);
    },

    async getFormData(data) {
      // console.log("data", data);
      let onboardingId = localStorage.getItem("activeOnboardingId");
      try {
        let result = await HTTP("post", "v1/get/form/with/task", {
          formId: data.id,
          onboardingId: onboardingId
        });
        // console.log("getFormSchema dtaa", result.data);
        let linkedForm = JSON.parse(result.data.form.schema);
        this.signatureForm = linkedForm.formSection[0].formElements[0];
        this.initializeFormData();
        this.showSignatureModal = true;
        this.onShowSig();
      } catch (error) {
        console.log("error----", error);
      }
    },

    makeToast() {
      const h = this.$createElement;
      const vNodesMsg = h("p", { class: ["text-center", "mb-0"] }, [
        h("b-spinner", { props: { type: "grow", small: true } }),
        // " We are generating your PDF... ",
        this.$t("toast.generatePDF"),
        h("b-spinner", { props: { type: "grow", small: true } })
      ]);
      this.$bvToast.toast([vNodesMsg], {
        variant: "warning",
        title: "PDF",
        autoHideDelay: 5000
      });
    },

    async downloadPdf(training, route) {
      console.log("training", JSON.parse(training.relatedtaskids))
      let parseId = JSON.parse(training.relatedtaskids);
      let subTaskOnoardingId = training.onboarding_id;
      let subTaskformId = parseId[0].formId;
      let formDefaultLanguage = localStorage.getItem("formDefaultLanguage");
      let onboardingId = localStorage.getItem("formDefaultLanguage");
      let formId = localStorage.getItem("formDefaultLanguage");
      let title = training.task_title + ".pdf";
      this.makeToast();
      axios({
        url: config.API_URL + `v1/mytpp/download/training/${subTaskOnoardingId}/${subTaskformId}`,
        // url: config.API_URL + "v1/mytpp/download/training/1053/214",
        method: "GET",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        },
        data: { formDefaultLanguage: formDefaultLanguage }
      })
        .then(response => {
          if (window.navigator.msSaveOrOpenBlob) {
            // let blob = response.data.blob;
            let blob = new Blob([response.data]);
            // IE11
            window.navigator.msSaveOrOpenBlob(blob, title);
            Helper.makeToast(
              this.$bvToast,
              "success",
              this.$t("toast.successPDF")

              // "PDF download successfully"
            );
            return;
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", title); //or any other extension
            document.body.appendChild(link);
            link.click();
            if (response) {
              Helper.makeToast(
                this.$bvToast,
                "success",
                this.$t("toast.successPDF")

                // "PDF download successfully"
              );
            }
          }
        })
        .catch(error => {
          Helper.makeToast(
            this.$bvToast,
            "danger",
            this.$t("toast.errorPDF")
            // "PDF not downloaded please try again"
          );
        });
    },

    async getForSchema() {
      console.log("getting form schema");
      try {
        let result = await HTTP("get", "/v1/get/form");
        console.log("setSubTask setSubTask dtaa", result);
      } catch (error) {
        console.log("error----", error);
      }
    },

    resetModal() {
      this.showSignatureModal = false;
      this.showSig = false;
    },

    onShowSig() {
      setTimeout(() => {
        this.showSig = true;
      }, 400);
    }
  }
};
</script>

<style scoped>
</style>
